<template>
<div class="main courseitem">
  <van-swipe v-if="banners" class="swipe" :autoplay="3000">
    <!-- <van-swipe-item>
      <img v-lazy="courseInfo.picture">
    </van-swipe-item> -->
    <van-swipe-item v-for="(img,index) in banners" :key="index">
      <!-- <img v-if="img.mime == 'mp4'" v-lazy="img.cover" @click="previewSwiper(banners,index)"> -->
      <video v-if="img.mime == 'mp4'" controls preload="auto" :poster="img.cover">
          <source :src="img.url" type="video/mp4">
          您的浏览器不支持 HTML5 视频,请更换浏览器。比如 Chrome 、 Firefox 等主流浏览器。
      </video>
      <img v-else v-lazy="img.url" @click="previewSwiper(banners,index)">
    </van-swipe-item>
  </van-swipe>
  <div class="bcw course-info">
    <header class="course-info__head">
      <h3>{{ courseInfo.title }}</h3>
      <div class="clear mtm mbm">
        <div class="clear left fs1 course-info__evaluate">
          <van-rate class="left" v-model="courseInfo.rating" :size="14" disabled-color="#FF6F0F" disabled />
          <span class="c9">评价{{ courseInfo.ratingNum }}</span>
          <span class="c9">参课{{ courseInfo.historyStudentNum }}人</span>
        </div>
        <div class="right c6 fs2">
          <span class="course-info__price">{{ courseInfo.price}}</span>/课时
        </div>
      </div>
    </header>
    <footer class="mtm course-info__foot fs2">
      <van-row>
        <van-col span="6">课程时间</van-col>
        <van-col span="18">60分钟/课时</van-col>
      </van-row>
      <van-row class="mtm address">
        <van-col span="6">上课地点</van-col>
        <van-col span="16"> 
          <router-link :to="{ name: 'venue',params:{clubId:clubInfo.id}}" class="clear mtm"><div class="mbn blue">{{ clubInfo.title }}</div> </router-link>
          <span class="c6">{{ clubInfo.address }}</span> 
        </van-col>
          <a :href="mapUrl" class="map c6"><i class="iconfont">&#xe635;</i></a>
      </van-row>
    </footer>
  </div>

  <div v-if="coachInfo.id" class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">教练信息</h3>
    </div>
    <div class="model-box__bd fs2 c6 mtm clear">
      <coach-card :coachInfo="coachInfo"></coach-card>
    </div>
  </div>
  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">课程信息</h3>
    </div>
    <div v-html="courseInfo.about" class="model-box__bd fs2 c6 mtm clear"></div>
  </div>
  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">购买须知</h3>
    </div>
    <div class="model-box__bd fs2 c6 mtm clear">
      <ol class="notice">
        <li>开课前可以购买课程；开课后无法购买；</li>
        <li>开课前可发起退款；开课后无法发起退款；</li>
        <li>开课前6小时之前可全额退，开课前6小时之内可退50%；</li>
        <li>官方发起课程取消（课程开始前180分钟购买用户不足1人，后台系统可能会自动取消课程，请大家知悉，谢谢理解与配合；当遇到不可抗力因素等不能按时开课的，在征得您同意的情况下，俱乐部可现场取消课程。）</li>
      </ol>
    </div>
  </div>
  <div class="model-box mtm bcw">
    <div class="model-box__hd clear">
      <h3 class="left">学员评价</h3>
    </div>
    <div class="model-box__bd fs2 c6 mtm clear">
      <evaluate-card v-for="(item,index) in reviewList" :key="index" :iteminfo="item" :type="manageType"></evaluate-card>
    </div>
  </div>
  <the-buybar :price="params.price" :oprice="params.price" :id="params.id" :isBuy="params.isBuy" :type="'clubPtCourse'" :queue="queueStatus" :ordertype="true"></the-buybar>
</div>
</template>
<script>
import Vue from 'vue';
import {
  Rate,
  Row,
  Col,
  Popup,
  Swipe,
  SwipeItem,ImagePreview
} from 'vant';
import TheBuybar from '@/components/TheBuybar'
import EvaluateCard from '@/components/EvaluateCard'
import AvatarBox from '@/components/AvatarBox'
import CoachCard from '@/components/CoachCard'
import AreaList from '@/assets/scripts/area'
import moment from 'moment'
import func from '@/assets/scripts/func';
moment.locale('zh-cn');
Vue.use(Rate).use(Row).use(Col).use(Popup).use(Swipe).use(SwipeItem).use(ImagePreview);

export default {
  name: 'CourseItem',
  components: {
    TheBuybar,
    EvaluateCard,
    AvatarBox,
    CoachCard,
  },
  data() {
    return {
      coachInfo: {},  // 教练
      courseInfo:{},  //课程
      clubInfo:{}, //俱乐部
      mapUrl:'',  // 导航地图
    //   arealist: AreaList, // 城市列表
      banners: '',  // 轮播图
      params: {},   //  支付按钮组件所需参数
      queueStatus: 0, // 排队状态
      reviewList: [], //评价列表
      manageType:''  //是否是教练
    }
  },
  created() {
      let _this = this;
      // 详情数据
      this.$http.get('club_pt_course/getInfo?courseId=' + this.$route.params.courseId).then(res => {
        console.log(res);
        this.coachInfo = res.data.value.coachInfo  //教练信息
        this.courseInfo = res.data.value.courseInfo  //课程信息
        this.reviewList = res.data.value.reviewList  //评价信息
        if(this.courseInfo.pictures!=''){
          this.banners = JSON.parse(this.courseInfo.pictures) 
        }
        this.clubInfo = res.data.value.courseInfo.clubInfo
        
        this.params.id = this.courseInfo.id
        this.params.type = 'course'
        this.params.price = this.courseInfo.price
        this.params.oprice = this.courseInfo.originPrice
        this.params.isBuy = this.courseInfo.isBuy

        this.courseInfo.startTime = moment(this.courseInfo.startTime*1000).format('YYYY年MM月DD日,a h:mm')
        this.mapUrl = 'https://apis.map.qq.com/tools/poimarker?type=1&keyword='+window.encodeURIComponent(this.clubInfo.title)+'&center='+ this.clubInfo.latitude + ',' + this.clubInfo.longitude +'&radius=1000&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp'

        if(this.courseInfo.studentNum >= this.courseInfo.maxStudentNum){
          if(this.courseInfo.isQueue){
            // 已排队
            this.queueStatus = -1;
          }else{
            // 未排队
            this.queueStatus = 1;
          }
        }else{
          // 可以购买
          this.queueStatus = 0;
        }
      })

      // 评价列表
      // this.$http.post('course_reviews/get',{
      //   courseId:this.$route.params.courseId,
      //   courseType:'coach'
      // }).then(res => {
      //   console.log(res)
      //   this.evaluationList = res.data.value
      // })


      // 获取用户信息
      // this.$http.post('user/judgeLogin').then(res => {
      //     console.log(res);
      //     if(res.data.code == 0){
      //       let roles = res.data.value.roles
      //       if(roles.indexOf('ROLE_COACH') !== -1){
      //         //教练
      //         this.manageType='manage'
      //       }
      //     }
      // });
  },
  methods: {
    showPopup: function() {
      if(this.userPics.length > 0){
        this.popupShow = true;
      }
    },
    previewSwiper: function(imgs,index){
        //放大图片路径 拼成数组
        var arr=[];         
        imgs.forEach((item, index) => {
             if(item.mime!='mp4'){
                  arr.push(item.url);
              }  
        })
        ImagePreview(arr, index);
    }
  }
}
</script>

<style lang="less">
.swipe{
    height: 1.8rem;
    img{ width: 100%; height: 100%; object-fit: cover; }
    video{width: 100%;height: 100%;}
}

.courseitem {
    padding-bottom: 0.7rem;
}
.course-info {
    padding: 0.15rem;
    &__head {
        border-bottom: 0.01rem #f6f6f6 solid;
    }
    &__evaluate {
        line-height: 0.2rem;
        color: #FF6600;
        &>.van-rate{
          margin-right: .1rem;
        }
    }
    &__price {
        font-size: 0.16rem;
        color: #f44;
    }
    &__price:before {
        content: '¥';
        font-size: 0.12rem;
        margin-right: 0.02rem;
    }

    &__enrolled {
        border-bottom: 0.01rem #f6f6f6 solid;
        & > div:first-child {
            line-height: 0.3rem;
        }
        // &__users{
        //     // line-height: .3rem;
    }
    &__avatar {
        float: left;
        width: 0.3rem;
        height: 0.3rem;
        margin-left: -.05rem;
        background-color: #f6f6f6;
        border-radius: 50%;
        border: 0.02rem solid white;
        text-align: center;
        color: #ddd;
        overflow: hidden;
        & > .iconfont {
            font-size: 0.14rem;
        }
    }
    &__foot {
      &>.address{
        position: relative;
        & .map i{position: absolute;right:0.05rem;top: 50%;margin-top: -0.1rem;font-size: 0.2rem}        
      }      
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/CoachCourseItem.vue